import React from 'react';

import PropTypes from 'prop-types';

import {
    MarkdownContent,
    Section,
    Typography,
} from 'wanderu-components';

import styles from './GeneralSection.scss';

function GeneralSection(props) {
    const {
        children,
        description,
        id,
        show = false,
        title,
    } = props;

    if (!show) {
        return null;
    }

    return (
        <Section id={id}>
            <Typography
                className={styles.container}
                component="h2"
                variant="h3"
            >
                {title}
            </Typography>
            <Typography
                component={MarkdownContent}
                paragraph
            >
                {description}
            </Typography>
            {children}
        </Section>
    );
}

GeneralSection.propTypes = {
    children: PropTypes.node,
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    show: PropTypes.bool,
    title: PropTypes.string.isRequired,
};

export default GeneralSection;
